import React from "react";

export default function LeetCodeIcon() {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      className="icon leetcode-icon"
      id="leetcode"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        stroke="none"
      >
        <path
          d="M2987 5106 c-21 -8 -55 -26 -75 -40 -57 -39 -2234 -2223 -2281 -2288
-93 -129 -145 -240 -188 -407 -19 -75 -26 -130 -30 -256 -8 -224 20 -384 96
-557 83 -186 112 -220 675 -784 287 -287 546 -539 576 -561 120 -86 240 -141
390 -180 118 -30 389 -43 520 -24 177 26 363 99 500 197 81 57 692 673 728
733 20 35 27 61 30 125 4 76 2 85 -30 146 -23 45 -48 76 -83 102 -61 46 -110
62 -193 61 -107 -1 -135 -22 -487 -363 -350 -338 -387 -366 -527 -394 -144
-30 -287 -14 -406 45 -73 36 -101 63 -700 669 -420 426 -432 441 -469 583 -21
81 -21 224 1 306 36 140 38 142 708 817 420 424 437 438 574 470 103 24 277
15 367 -18 37 -14 85 -38 107 -53 21 -15 174 -158 340 -318 167 -161 324 -307
351 -326 44 -31 57 -35 133 -39 74 -4 90 -1 137 20 110 51 170 139 177 259 8
134 1 143 -361 507 -172 172 -341 336 -377 363 -80 61 -257 151 -345 174 l-66
18 274 276 c173 174 283 293 298 321 34 65 34 195 0 262 -29 57 -81 109 -141
140 -55 28 -166 35 -223 14z"
        />
        <path
          d="M2208 2336 c-213 -58 -277 -344 -111 -497 81 -74 -14 -69 1260 -69
l1148 0 50 24 c84 39 138 113 153 210 17 107 -15 204 -88 270 -85 77 15 71
-1240 73 -888 1 -1135 -1 -1172 -11z"
        />
      </g>
    </svg>
  );
}
